import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// types
import Event from '../../interfaces/Event.interface';

interface EventsState {
  events: Event[];
}

const initialState: EventsState = {
  events: [],
};

function sortEvents(eventA: Event, eventB: Event) {
  return new Date(eventA.startTime).getTime() - new Date(eventB.startTime).getTime();
}

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setEvents: (state, action: PayloadAction<Event[]>) => {
      state.events = action.payload;
      state.events.sort(sortEvents);
    },
    createEvent: (state, action: PayloadAction<Event>) => {
      state.events.push(action.payload);
      state.events.sort(sortEvents);
    },
    updateEvent: (state, action: PayloadAction<Event>) => {
      const index = state.events.findIndex((event) => event.id === action.payload.id);
      if (index !== -1) {
        state.events[index] = action.payload;
      }
      state.events.sort(sortEvents);
    },
    deleteEvent: (state, action: PayloadAction<number>) => {
      state.events = state.events.filter((event) => event.id !== action.payload);
    },
    clearExcuse(state, action: PayloadAction<number>) {
      state.events = state.events
        .map((event) =>
          event.id === action.payload ? {
            ...event,
            excused: false,
            excuseExpiresAt: null,
          } : event
        );
    },
  },
});

export const {
  setEvents,
  createEvent,
  updateEvent,
  deleteEvent,
  clearExcuse,
} = eventsSlice.actions;

export default eventsSlice.reducer;
